<template>
  <teleport to="body">
    <div v-if="open" class="fixed inset-0 z-[99998] flex items-center justify-center p-5 bg-black/60 backdrop-blur-sm"
      @click.self="$emit('dismiss')">
      <div class="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div class="px-6 py-5 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white">
          <div class="flex items-start gap-4">
            <div
              class="w-12 h-12 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0 overflow-hidden">
              <img v-if="appIcon" :src="appIcon" :alt="appName" class="w-12 h-12 object-cover" />
              <svg v-else class="w-7 h-7" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M21 12a9 9 0 1 1-18 0" />
                <path d="M21 3v9h-9" />
                <path d="M21 12a9 9 0 0 0-9-9" />
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs uppercase tracking-[0.3em] text-white/75 font-semibold">
                Actualización disponible
              </p>
              <h3 class="text-lg font-semibold leading-tight">{{ appName || 'Aplicación' }} tiene una nueva versión</h3>
              <p v-if="deviceBadge" class="text-xs text-white/80 mt-1">{{ deviceBadge }}</p>
            </div>
            <button class="text-white/80 hover:text-white transition-colors" type="button" aria-label="Cerrar"
              @click="$emit('dismiss')">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div class="px-6 py-6 space-y-4">
          <p class="text-sm text-gray-700">
            Hay mejoras disponibles. Presiona <strong>Actualizar</strong> para cargar la versión más reciente.
          </p>

          <div class="flex items-center justify-end gap-2">
            <button type="button"
              class="px-4 py-2 rounded-xl bg-gray-100 text-gray-700 font-semibold text-sm hover:bg-gray-200 transition-colors"
              @click="$emit('dismiss')">
              Ahora no
            </button>
            <button type="button"
              class="px-5 py-2 rounded-xl bg-blue-600 text-white font-semibold text-sm hover:bg-blue-700 transition-colors disabled:opacity-70"
              :disabled="updating" @click="$emit('accept')">
              {{ updating ? 'Actualizando…' : 'Actualizar' }}
            </button>
          </div>

          <p class="text-[12px] text-gray-500">La actualización se aplica recargando la app.</p>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'PWAUpdateModal',
  props: {
    open: { type: Boolean, default: false },
    updating: { type: Boolean, default: false },
    deviceBadge: { type: String, default: '' },
    appName: { type: String, default: '' },
    appIcon: { type: String, default: '' }
  },
  emits: ['accept', 'dismiss']
}
</script>
